export enum RosterFileStatus {
  scheduled = 'Scheduled',
  processing = 'Processing',
  complete = 'Complete',
  newPatients = 'new patients',
  error = 'Error',
}
